/**
 * Services Section — Accordion behavior
 */

/**
 * Initialize accordion: single-open, keyboard accessible (Enter/Space/Escape).
 */
function initAccordions() {
  var accordions = document.querySelectorAll('.accordion');
  if (!accordions.length) return;

  // Set initial open panel height
  accordions.forEach(function (accordion) {
    var panel = accordion.querySelector('.accordion__panel');
    if (accordion.getAttribute('data-state') === 'open' && panel) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });

  // Delegated click handler
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;

    var accordion = trigger.closest('.accordion');
    if (!accordion) return;

    var panel = accordion.querySelector('.accordion__panel');
    var isOpen = accordion.getAttribute('data-state') === 'open';

    if (isOpen) {
      accordion.setAttribute('data-state', 'closed');
      trigger.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = '0';
    } else {
      // Close all siblings first
      var siblings = accordion.parentElement.querySelectorAll('.accordion');
      siblings.forEach(function (sib) {
        sib.setAttribute('data-state', 'closed');
        var sibTrigger = sib.querySelector('.accordion__trigger');
        var sibPanel = sib.querySelector('.accordion__panel');
        if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
        if (sibPanel) sibPanel.style.maxHeight = '0';
      });

      // Open clicked
      accordion.setAttribute('data-state', 'open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });

  // Keyboard: Enter and Space trigger click
  document.addEventListener('keydown', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      trigger.click();
    }
  });
}
